import { is, isEmpty, omit } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import Button from '../../../packages/kiti/components/actions/Button'
import Line from '../../../packages/kiti/components/helpers/Line'
import Text from '../../../packages/kiti/components/presentation/Text'

const OMIT_FIELDS = ['insertedAt', 'updatedAt', 'deleted', 'enabled', '__typename']

export const DatePickerFooter = ({ closeModal, onChange, handleClear }) => {
  const { t } = useTranslation('common')
  const { form } = useFormState()
  const buttonLabel = t('confirm') + (is(Array, form) ? ` (${form?.length})` : '')
  const OMIT_FIELDS = ['insertedAt', 'updatedAt', 'deleted', 'enabled', '__typename']

  return (
    <Grid justify="flex-end" align="center" gap={0.5} padding={1}>
      {!isEmpty(form) && (
        <>
          <Line vertical height={0.6} color="dark5" />
          <Text color="red" size="xsmall" onClick={handleClear}>
            {t('clearSelection')}
          </Text>
        </>
      )}

      <Col flex={1} />
      <Button
        onClick={() => {
          onChange(is(Array, form) ? form?.map(item => omit(OMIT_FIELDS, item)) : omit(OMIT_FIELDS, form))
          closeModal()
        }}
      >
        {buttonLabel}
      </Button>
    </Grid>
  )
}

const ModalPickerFooter = ({ closeModal, onChange, children }) => {
  const { t } = useTranslation('common')
  const { form, handleChangeIn } = useFormState()
  const buttonLabel = t('confirm') + (is(Array, form) ? ` (${form?.length})` : '')

  return (
    <Grid justify="flex-end" align="center" gap={0.5} padding={1}>
      {children}

      {!isEmpty(form) && (
        <>
          <Line vertical height={0.6} color="dark5" />

          <Text color="red" size="xsmall" onClick={() => handleChangeIn([], [])}>
            {t('clearSelection')}
          </Text>
        </>
      )}

      <Col flex={1} />
      <Button
        onClick={() => {
          onChange(is(Array, form) ? form?.map(omit(OMIT_FIELDS)) : omit(OMIT_FIELDS, form))
          closeModal()
        }}
      >
        {buttonLabel}
      </Button>
    </Grid>
  )
}

export default ModalPickerFooter
